import React from 'react';
import CrudManager from '@/components/admin/CrudManager';

const AdminProducts = () => (
  <CrudManager
    title="Products"
    subtitle="Manage catalog, pricing, ingredients, images."
    endpoint="/admin/products"
    idField="product_id"
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'slug', label: 'Slug' },
      { key: 'price', label: 'Price', render: (p) => `₹${p.price}` },
      { key: 'stock', label: 'Stock' },
      { key: 'featured', label: 'Featured', render: (p) => p.featured ? '✓' : '' },
      { key: 'tags', label: 'Tags', render: (p) => (p.tags || []).join(', ') },
    ]}
    initial={{ slug: '', name: '', tagline: '', price: 0, compare_at: 0, image: '', gallery: [], size: '', description: '', ingredients: [], benefits: [], directions: '', safety: '', tags: [], featured: false, stock: 100, seo_title: '', seo_description: '', category: '' }}
    fields={[
      { key: 'slug', label: 'Slug (URL)', required: true, placeholder: 'triphala-churna' },
      { key: 'name', label: 'Name', required: true },
      { key: 'tagline', label: 'Tagline' },
      { key: 'price', label: 'Price (₹)', type: 'number', required: true },
      { key: 'compare_at', label: 'Compare-at price (₹)', type: 'number' },
      { key: 'size', label: 'Size (e.g. 100g)' },
      { key: 'image', label: 'Cover image', type: 'image', help: 'Drag & drop or click to upload. Shown as the main product photo.' },
      { key: 'gallery', label: 'Gallery images', type: 'image-array', help: 'Drag & drop multiple images. First becomes the cover fallback; the rest appear as a thumbnail carousel.' },
      { key: 'description', label: 'Description', type: 'textarea', rows: 4 },
      { key: 'ingredients', label: 'Ingredients (one per line)', type: 'array' },
      { key: 'benefits', label: 'Benefits (one per line)', type: 'array' },
      { key: 'directions', label: 'Directions for use', type: 'textarea', rows: 2 },
      { key: 'safety', label: 'Safety information', type: 'textarea', rows: 2 },
      { key: 'tags', label: 'Tags / concerns (one per line, use concern slugs)', type: 'array', help: 'e.g. gut-health, sleep, stress' },
      { key: 'stock', label: 'Stock', type: 'number' },
      { key: 'featured', label: 'Featured on homepage', type: 'checkbox' },
      { key: 'category', label: 'Category' },
      { key: 'seo_title', label: 'SEO title' },
      { key: 'seo_description', label: 'SEO description', type: 'textarea', rows: 2 },
    ]}
  />
);
export default AdminProducts;
